import request from './request';

// 获取团队成员
export function getTeamList() {
  return request({
    url: '/gw/team',
    method: 'get',
  });
}

// 获取案例
export function getCaseList() {
  return request({
    url: '/gw/case',
    method: 'get',
  });
}

// 提交留言
export function submitMessage(data) {
  return request({
    url: '/gw/liuzi',
    method: 'post',
    data,
  });
}

// 获取案例详情
export function getCaseDetail(params) {
  return request({
    url: '/gw/casedetail',
    method: 'get',
    params,
  });
}

// 获取荣誉
export function getHonorList() {
  return request({
    url: '/gw/honor',
    method: 'get',
  });
}

// 获取业务
export function getBusinessList() {
  return request({
    url: '/gw/business',
    method: 'get',
  });
}

// 获取微信分享签名
export function getWxShareSign() {
  return request({
    url: '/gw/wxshare',
    method: 'get',
  });
}

// 将所有接口函数整理为一个对象导出
export default {
  getTeamList,
  getCaseList,
  submitMessage,
  getCaseDetail,
  getHonorList,
  getBusinessList,
  getWxShareSign,
};
